import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ValidatorFunction } from '@widgets/validation'
import { FormHelperService } from './services/form-helper.service'

@Component({
  selector: 'bdg-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form.component.html',
})
export class FormComponent implements OnChanges {
  @Input()
  formGroup: FormGroup

  @Input()
  formValidator: ValidatorFunction<any>

  @Output()
  formSubmit: EventEmitter<any> = new EventEmitter()

  constructor(private formHelper: FormHelperService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formGroup) {
      this.detourBlur()
    }
  }

  onSubmit = () => {
    this.formHelper.touchAll(this.formGroup)
    this.formSubmit.emit()
  }

  private detourBlur() {
    /* eslint-disable @typescript-eslint/dot-notation */
    const markAsTouched = this.formGroup['markAsTouched']
    this.formGroup['markAsTouched'] = (opts?) => {
      markAsTouched.apply(this.formGroup, opts)
      if (this.formValidator) {
        const validationErrors = this.formValidator(this.formGroup.getRawValue())
        this.formHelper.notifyErrors(this.formGroup, validationErrors)
      }
    }
    /* eslint-enable @typescript-eslint/dot-notation */
  }
}
